export class PackagePlan {
  id: string = '--';
  name: string = 'planname';
  units: number = 600;
  validity: number= 0;
  priceUSD: number= 1.23;

  constructor(id: string, name: string = '--', priceUSD: number =0, units: number=0, validity: number=0) {
    this.id = id;
    this.name = name;
    this.priceUSD = priceUSD;
    this.units = units;
    this.validity = validity;
  }
}
